/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务2）。
 * Hero 区块（partnership_home.html 第 1 行起）：悬浮 logo + 环形轮盘 + 双 CTA + 装饰背景。
 * 注意事项：
 *  - 静态文案取自 props.t（getConstants().HERO，i18next 六国翻译）。
 *  - 悬浮合作方为品牌名（Shopify/amazon 等专有名词），保持静态不翻译。
 *  - Explore Partners 锚点指向真实 section id #cj-partner-directory-v2（HTML 原 href 与 id 不一致，以可用 id 为准）。
 */
import React, { useState, useEffect } from 'react';
// 260715 第17次补充(需求㊷)：hero 中心图本地化，下载至 asset/images/partnership 经 webpack 引用，不再外链 unsplash
import heroPartnerImg from 'asset/images/partnership/hero-partner.jpg';

const FLOATING = [
  { cls: 'partner-shopify', logoCls: 'shopify-logo', text: 'Shopify' },
  { cls: 'partner-amazon', logoCls: 'amazon-logo', text: 'amazon' },
  { cls: 'partner-tiktok', logoCls: 'tiktok-logo', text: 'TikTok Shop' },
  { cls: 'partner-paypal', logoCls: 'paypal-logo', text: 'PayPal' },
  { cls: 'partner-hubspot', logoCls: 'hubspot-logo', text: 'HubSpot' },
  { cls: 'partner-dhl', logoCls: 'dhl-logo', text: 'DHL' },
  { cls: 'partner-google', logoCls: 'google-logo', text: 'Google' },
];

export default function HeroSection({ t }) {
  const c = t || {};
  const ringLabels = c.ringLabels || [];
  // 260714 第14次补充追加(需求㉘)：Explore Partners 仅未登录展示、已登录隐藏；Become a Partner 一直展示。
  //   登录态由客户端 window.CJ_isLogin 判定：SSR/未就绪默认展示(不闪隐)，客户端探测到已登录后隐藏；轮询等 CJ_isLogin 就绪(与工单同时序根因)。
  const [isLogged, setIsLogged] = useState(false);
  useEffect(function () {
    if (typeof window === 'undefined') return undefined;
    var tries = 0;
    var timer;
    var check = function () {
      if (window.CJ_isLogin) { setIsLogged(true); return; }
      if (typeof window.CJ_isLogin !== 'undefined') return; // 就绪且未登录：保持展示
      if (tries < 25) { tries += 1; timer = setTimeout(check, 120); }
    };
    check();
    return function () { if (timer) clearTimeout(timer); };
  }, []);
  // 260714 第14次补充追加(需求㉚)：点击跳登录页并带 target=base64(当前 url)，登录后跳回本页(/partnership/home)。
  //   与工单登录回跳同约定(/login.html?target=<base64(url)>)；SSR/无 window 时退化为普通 /login.html。
  function goLogin(e) {
    if (typeof window === 'undefined') return;
    e.preventDefault();
    var url = window.location.href;
    var enc = typeof window.btoa === 'function' ? window.btoa(url) : encodeURIComponent(url);
    window.location.href = '/login.html?target=' + enc;
  }
  return (
    <section className="cj-partner-hero">
      <div className="cj-partner-bg-circle cj-circle-1" />
      <div className="cj-partner-bg-circle cj-circle-2" />
      <div className="cj-partner-bg-circle cj-circle-3" />

      <div className="cj-partner-hero-inner">
        <div className="cj-partner-content">
          <div className="cj-partner-label">{c.label}</div>
          <h1>
            {c.title} <span>{c.titleHighlight}</span>
          </h1>
          <p>{c.desc}</p>
          <div className="cj-partner-actions">
            {/* 260714 第14次补充追加(需求㉖/㉘/㉚)：Join {fullName} 按钮，仅未登录展示；点击跳登录页，
                并带 target=base64(当前 url)，登录完成后跳回本页(/partnership/home)。 */}
            {!isLogged ? (
              <a href="/login.html" onClick={goLogin} className="cj-partner-btn cj-btn-primary">
                {c.explore}
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </a>
            ) : null}
            {/* 260713163000（第8次补充 任务1.5）：因为需求要求与原页 partnership-join-btn(toAdd→/partnership-add.html) 一致，由 WhatsApp 改为 /partnership-add.html（同窗跳转）。 */}
            <a href="/partnership-add.html" className="cj-partner-btn cj-btn-secondary">
              {c.become}
            </a>
          </div>
        </div>

        <div className="cj-partner-visual">
          {FLOATING.map((f) => (
            <div className={'cj-floating-partner ' + f.cls} key={f.cls}>
              <span className={'partner-logo ' + f.logoCls}>{f.text}</span>
            </div>
          ))}

          <div className="cj-partner-wheel">
            <div className="cj-wheel-glow" />
            <div className="cj-wheel-ring">
              <div className="cj-wheel-center">
                <img
                  src={heroPartnerImg}
                  alt="Ecommerce business partner"
                />
              </div>
              {ringLabels.map((l) => (
                <span className={'cj-ring-label ' + l.cls} key={l.cls}>{l.text}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
